import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles(() => ({
  sizeSmall: {
    minWidth: 18,
    fontSize: 16,
    minHeight: 18,
  },
  labelSmall: {
    lineHeight: "18px"
  }
}));

export default useStyle;
